module.exports = __webpack_public_path__ + "3b1357b0c3605ba1ff45d45ba54705c9.jpg";